import axios from "axios";
import {
  COUNT,
  FETCH_COUNTER,
  DEC_COUNT,
  INTEREST_TOGGLE,
  INTEREST_FETCH,
  EMAIL_CONFIRMATION,
  EMAIL_VERIFICATION,
  FORGET_PASSWORD,
  GOVT_ID_VERIFICATION,
  RESET_PASSWORD,
  SIGNIN,
  SIGNOUT,
  SIGNUP,
  SUBSCRIBE,
  VERIFY,
  UPDATE_ACCOUNT,
  ACCOUNT_INFO,
} from "config/api-const";

export const onSignUp = async (userObj) =>
  await axios.post(SIGNUP, { userObj });

export const onSignIn = async ({ emailAddress, mobileNumber, password }) =>
  await axios.post(SIGNIN, {
    ...(mobileNumber ? { mobileNumber } : { emailAddress }),
    password,
  });

export const onSignOut = async (token) =>
  token && (await axios.get(SIGNOUT + token));

export const verifyToken = async (token) =>
  token && (await axios.get(VERIFY + token));

export const subscribe = async (emailAddress) =>
  emailAddress && (await axios.post(SUBSCRIBE, { emailAddress: emailAddress }));

export const forgetPassword = async (emailAddress) =>
  emailAddress && (await axios.post(FORGET_PASSWORD, { emailAddress }));

export const resetPassword = async (token, password) =>
  token && password && (await axios.post(RESET_PASSWORD + token, { password }));

export const verifyEmail = async (id) =>
  id && (await axios.post(EMAIL_VERIFICATION, { id }));

export const confirmEmail = async (token) =>
  token && (await axios.post(EMAIL_CONFIRMATION + token));

export const createCount = async (id) =>
  id && (await axios.post(COUNT, { id }));

export const decrementCount = async (id, profileId) =>
  id && (await axios.put(`${DEC_COUNT}${id}/${profileId}`));

export const fetchCounter = async (id) =>
  id && (await axios.get(`${FETCH_COUNTER}${id}`));

export const toggleInterest = async (senderId, receiverId) =>
  senderId &&
  receiverId &&
  (await axios.post(INTEREST_TOGGLE, { senderId, receiverId }));

export const fetchInterests = async (userId) =>
  userId && (await axios.get(`${INTEREST_FETCH}${userId}`));

export const govtIdVerification = async (id) =>
  id && (await axios.put(GOVT_ID_VERIFICATION, { id }));

export const fetchAccountInfo = async (userId, token) => {
  return axios.get(ACCOUNT_INFO, { params: { userId, token } });
};

export const updateAccount = async ({
  userId,
  oldUsername, // add this
  username,
  emailAddress,
  mobileNumber,
  language,
  profileStatus,
}) => {
  return axios.put(UPDATE_ACCOUNT, {
    userId,
    oldUsername, // add this
    username,
    emailAddress,
    mobileNumber,
    language,
    profileStatus,
  });
};
